import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { courseMaterialsTable } from '@/mocks/materialsData';

const COURSE_COUNT = 3;

export default function CourseMaterialsTable() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('materials.table.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('materials.table.title')}
          </h2>
          {String(t('materials.table.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('materials.table.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mt-5 max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="hidden md:block overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-primary-800">
                <th className="p-4 text-left text-accent-400 font-heading text-[15px] tracking-[0.06em] whitespace-nowrap">
                  {t('materials.table.col.course')}
                </th>
                <th className="p-4 text-left text-accent-400 font-heading text-[15px] tracking-[0.06em] whitespace-nowrap">
                  {t('materials.table.col.pages')}
                </th>
                <th className="p-4 text-left text-accent-400 font-heading text-[15px] tracking-[0.06em] whitespace-nowrap">
                  {t('materials.table.col.textbooks')}
                </th>
                <th className="p-4 text-left text-accent-400 font-heading text-[15px] tracking-[0.06em] whitespace-nowrap">
                  {t('materials.table.col.note')}
                </th>
                <th className="p-4 w-16"></th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: COURSE_COUNT }, (_, idx) => (
                <tr
                  key={idx}
                  className="border-b border-background-200/50 hover:bg-background-100/60 transition-colors"
                >
                  <td className="p-4">
                    <p className="font-heading text-[16px] text-foreground-900 tracking-[0.05em]">
                      {t(`materials.table.${idx}.name`)}
                    </p>
                    <p className="text-[13px] text-foreground-400 tracking-[0.06em] mt-0.5">
                      {courseMaterialsTable.courses[idx].nameEn}
                    </p>
                  </td>
                  <td className="p-4">
                    <span className="text-[16px] text-foreground-700 tracking-[0.04em] font-medium">
                      {t(`materials.table.${idx}.pages`)}
                    </span>
                  </td>
                  <td className="p-4">
                    <span className="text-[15px] text-foreground-500 tracking-[0.04em]">
                      {t(`materials.table.${idx}.textbooks`)}
                    </span>
                  </td>
                  <td className="p-4">
                    <span className="text-[14px] text-foreground-400 tracking-[0.03em]">
                      {t(`materials.table.${idx}.note`)}
                    </span>
                  </td>
                  <td className="p-4">
                    <Link
                      to={courseMaterialsTable.courses[idx].href}
                      className="inline-flex items-center gap-1 text-[14px] text-accent-500 hover:text-accent-400 tracking-[0.05em] transition-colors whitespace-nowrap"
                    >
                      {t('materials.table.viewDetail')}
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-[12px]"></i>
                      </div>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="md:hidden space-y-4">
          {Array.from({ length: COURSE_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="border border-background-200/60 bg-background-100/60 p-5"
            >
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="font-heading text-[17px] text-foreground-900 tracking-[0.05em]">
                    {t(`materials.table.${idx}.name`)}
                  </p>
                  <p className="text-[13px] text-foreground-400 tracking-[0.06em] mt-0.5">
                    {courseMaterialsTable.courses[idx].nameEn}
                  </p>
                </div>
                <span className="text-[16px] text-accent-600 font-medium tracking-[0.04em]">
                  {t(`materials.table.${idx}.pages`)}
                </span>
              </div>
              <div className="flex flex-col gap-1.5 mb-4">
                <div className="flex items-center gap-2">
                  <span className="text-[13px] text-foreground-400 tracking-[0.04em] w-16 flex-shrink-0">
                    {t('materials.table.mobileLabel.textbooks')}
                  </span>
                  <span className="text-[14px] text-foreground-500 tracking-[0.04em]">
                    {t(`materials.table.${idx}.textbooks`)}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[13px] text-foreground-400 tracking-[0.04em] w-16 flex-shrink-0">
                    {t('materials.table.mobileLabel.note')}
                  </span>
                  <span className="text-[14px] text-foreground-400 tracking-[0.03em]">
                    {t(`materials.table.${idx}.note`)}
                  </span>
                </div>
              </div>
              <Link
                to={courseMaterialsTable.courses[idx].href}
                className="inline-flex items-center gap-1 text-[14px] text-accent-500 hover:text-accent-400 tracking-[0.05em] transition-colors"
              >
                {t('materials.table.viewCourse')}
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[12px]"></i>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {String(t('materials.table.footerNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">{__s}</p>))}
      </div>
    </section>
  );
}
